import React, { useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import '../TimesheetEntry.scss';
import { TimesheetStatusDisplayValue } from 'constants/statusValues';
import { getLocalDateTime } from 'utils/utils';
import { CollapseIcon } from 'assets/images/CollapseIcon/CollapseIcon';
import { ExpandIcon } from 'assets/images/ExpandIcon/ExpandIcon';

const TimesheetStatusHistory = ({ timesheetStatushistories }) => {
  const [showHistory, setShowHistory] = useState(false);

  const sortedHistories = timesheetStatushistories
    ?.slice()
    .sort((a, b) => new Date(a.updatedDate) - new Date(b.updatedDate));

  return (
    <div className="aepContainer">
      <div className="addBtn addClassification">
        <Button
          active={false}
          variant="link"
          onClick={() => setShowHistory(!showHistory)}
        >
          <div
            style={{
              display: 'inline-block',
              verticalAlign: 'middle',
              marginRight: '10px',
            }}
          >
            {showHistory ? (
              <ExpandIcon size={18} />
            ) : (
              <CollapseIcon size={18} />
            )}
          </div>
          <span
            className="addAttachmentText"
            style={{ verticalAlign: 'middle' }}
          >
            Timesheet Status History and Comments
          </span>
        </Button>

        {showHistory && (
          <div className="tableContainer">
            <Table
              hover
              responsive
              striped
              bordered={false}
              className="timesheetStatusHistoryTable"
              style={{ width: '70%', maxWidth: '1500px' }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      width: 'auto',
                      whiteSpace: 'nowrap',
                      marginRight: '10px',
                    }}
                  >
                    Updated Date
                  </th>
                  <th
                    style={{
                      width: 'auto',
                      whiteSpace: 'nowrap',
                      marginRight: '4px',
                    }}
                  >
                    Status
                  </th>
                  <th style={{ width: '600px' }}>Comments</th>
                  <th
                    style={{
                      width: 'auto',
                      whiteSpace: 'nowrap',
                      marginRight: '10px',
                    }}
                  >
                    Updated By
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedHistories?.map((obj, index) => (
                  <tr key={index} className="tRow table-hover-row">
                    <td>{getLocalDateTime(obj.updatedDate)}</td>
                    <td>{TimesheetStatusDisplayValue[obj.caastatus]}</td>
                    <td>{obj.comments}</td>
                    <td>{obj.updatedByName}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </div>
  );
};

export default TimesheetStatusHistory;
